<!-- Header -->
<ion-header class="ion-no-border">
  <ion-toolbar mode="ios">
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<!-- Content -->
<ion-content [scrollY]="false">
  <ion-label class="title"> {{ 'PUBLIC.signup.title' | translate }} </ion-label>
  <p [innerHTML]="'PUBLIC.signup.instructions' | translate:{ url: getSignupLink() }"></p>
  <ion-button data-cy="public.signup.redirect" (click)="redirectToSignup()" mode="ios">
    <ion-icon slot="end" name="log-in-outline"></ion-icon>
    <span></span>{{ 'PUBLIC.signup.cta' | translate }}
  </ion-button>
</ion-content>
